import Entity from '../entity'
export default class ServicioMensajeria extends Entity<number>{
    alias : string;
}
